/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Outlet, useParams } from "react-router-dom";
import "../../styles/DoctaAi.css";
// import "../components/DoctaAi/doctaAi.css";
import MyContext from "../components/Mycontext";
import "./index.css";

import DoctaAiChat from "./DoctaAiChat";
import DoctaAiRecord from "./DoctaAiRecord";
import toast from "react-hot-toast";
import {
	createConversation,
	deleteConversation,
	getConversation,
	GetSessionIdApi,
	getUserAllConversationSummary,
} from "../../api/Api";
import { useAuth } from "../../providers/AuthProvider";
import { useTheme } from "../../providers/CustomThemeProvider";
import { useSse } from "../components/useSse";
import { useTranslation } from "react-i18next";
import {Button} from "antd";

interface SessionKeyResponse {
	sessionKey: string;
}

function DoctaAi() {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	const { id: convId } = useParams<{ id: string }>(); // 获取 id 参数

	// 判断是否登录，如果是未登录则跳转去登录页面
	const token = localStorage.getItem("token");

	useEffect(() => {
		if (!token) {
			toast.error("No valid token");
			navigate("/login");
		}
	}, [token]);

	const [listen, setListen] = useState<boolean>(false);

	// for websocket
	const [sessionId, setSessionId] = useState<string>(
		sessionStorage.getItem("sessionId") ?? ""
	);

	const [messageId, setMessageId] = useState<number | string | undefined>("");

	const userdetail = useAuth();
	const user = userdetail?.userInfo;
	const [hideSide, setHideSide] = useState(false);

	const [selectedChat, setSelectedChat] = useState(
		JSON.parse(localStorage.getItem("selectedChat") ?? "{}") ?? ({} as any)
	);
	const [isInputValue, setIsInputValue] = useState(false);
	const [conversationId, setConversationId] = useState<any>(
		JSON.parse(localStorage.getItem("conversationId") ?? "0") ?? 0
	);
	const [recordList, setRecordList] = useState<any>([]);
	const [save, setSave] = useState<boolean>(false);

	// 整个右边聊天记录的 loading
	const [isLoad, setIsLoad] = useState(false);

	const [file, setFile] = useState<File | null>(null);
	const [fileUrl, setFileUrl] = useState<string>("");
	const { isDarkMode, switchTheme } = useTheme();

	// 用户需要的返回类型
	const [requireType, setRequireType] = useState<string>("text");
	const [current, setCurrent] = useState<any>([]);
	const [chatListData, setChatListData] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);


	// const { message, sendMessage, streamMessages, save } = useWebSocket(
	// 	user?.userId && sessionId
	// 		? `wss://${process.env.REACT_APP_BASE_URL}/websocket/${sessionId}`
	// 		: ""
	// );

	const { message, sendMessage, streamMessages } = useSse(
		setSave,
		setIsLoading
	);

	const [needFresh, setNeedFresh] = useState<boolean>(false);

	useEffect(() => {
		if (!convId) return;
		setConversationId(convId);
		localStorage.setItem("conversationId", JSON.stringify(convId)?.toString());
	}, [convId]);

	const customSetSelectChat = (value: any) => {
		setSelectedChat(value);
		localStorage.setItem(
			"selectedChat",
			JSON.stringify(value)?.toString() ?? {}.toString
		);
	};

	const customSetConversationId = (value: any) => {
		setConversationId(value);
		localStorage.setItem("conversationId", JSON.stringify(value)?.toString());
	};

	const getSessionId = async () => {
		try {
			const res: SessionKeyResponse = (await GetSessionIdApi()) as any;
			console.log("sessionKey:", res?.sessionKey);
			setSessionId(res?.sessionKey);
			sessionStorage.setItem("sessionId", res?.sessionKey);
		} catch (e) {
			console.log(e);
		}
	};

	useEffect(() => {
		if (!sessionId) {
			getSessionId();
		}
	}, []);

	const checkScreenWidth = () => {
		if (window.innerWidth < 768) {
			setHideSide(true);
		} else {
			setHideSide(false);
		}
	};

	useEffect(() => {
		// 初始判断屏幕宽度
		checkScreenWidth();

		// 添加resize事件监听器
		window.addEventListener("resize", checkScreenWidth);

		// 清理事件监听器
		return () => {
			window.removeEventListener("resize", checkScreenWidth);
		};
	}, []);

	useEffect(() => {
		console.log(conversationId);
	}, [conversationId]);

	const addSession = (is = false) => {
		// setCurrent([]);
		const currentDate = new Date();
		const formattedDate = currentDate.toISOString();
		// setIsInputValue(false);

		if (!user) {
			return;
		}

		const obb = {
			userId: user?.userId,
			title: "Chatbot definition expl",
			date: formattedDate,
			deleted: true,
			messages: [],
		};
		const list = JSON.parse(JSON.stringify(obb));

		// setSelectedChat(list);
		customSetSelectChat(list);
		customSetConversationId(0);

		if (is) {
			setRecordList([list]);
			// customSetConversationId(0);
		}
	};

	const seleConversation = (id: any) => {
		if (!id) {
			return;
		}
		// setCurrent([]);
		navigate(`/d5data/c/${id}`);
		// setIsLoad(true);

		// setIsInputValue(true);
		if (id) {
			getConversationList(id);
		}
	};

	const getConversationList = async (conid: any) => {
		if (!conid) return;
		conid != id && setIsLoad(true);

		try {
			const res = await getConversation({ id: conid });
			conid != id && setIsLoad(false);

			const data = JSON.parse(JSON.stringify(res));
			// setConversationId(data.id);
			customSetConversationId(data.id);
			// setSelectedChat(data);
			// setCurrent([]);
			customSetSelectChat(data);
			console.log(
				"getConversationListgetConversationListgetConversationList",
				data?.messages?.length
			);
			data?.messages?.length > 1 && setIsInputValue(false);
		} catch (e) {
			conid != id && setIsLoad(false);
		}
	};

	const deleItem = (id: string | number) => {
		if (!id) {
			return;
		}
		// setConversationId(0);
		// setSelectedChat({} as any);
		customSetConversationId(0);
		customSetSelectChat({} as any);
		deleteConversation({ id: id }).then((res) => {
			console.log(res, "删除成功");
			getList(true);
		});
		navigate("/d5data");
	};

	const getList = (chooseFirst = false) => {
		getUserAllConversationSummary({ type: 1 })
			.then((res: object) => {
				const data = JSON.parse(JSON.stringify(res));
				setRecordList(data?.summaryList);
				if (data?.summaryList.length > 0) {
					// 如果当前没有选中会话的话默认选中第一条
					if (chooseFirst || !conversationId) {
						addSession();
					}
				} else {
					// 如果当前没有会话记录默认新增一条
					addSession(true);
				}
			})
			.catch((e: any) => {
				console.log(e);
			});
	};
	const { id } = useParams<{ id: string }>(); // 获取 id 参数

	useEffect(() => {
		id && seleConversation(id);
		const timer = setTimeout(getList, 1000);
		return () => clearTimeout(timer);
	}, [user, id]);

	const handleChange = (value: string, fileUrl?: any) => {
		console.log("handleChangehandleChangehandleChangehandleChangehandleChange");
		if (value == "" && fileUrl == "") {
			return;
		}
		setIsInputValue(true);
		addMessage(value, fileUrl);
	};

	const createMessage = (Id: number, value: string, fileUrl: string = "") => {
		let modality = "";
		if (fileUrl != "" && requireType == "img") {
			modality = "img2img";
		} else if (fileUrl == "" && value != "" && requireType == "img") {
			modality = "text2img";
		} else {
			// 暂时没有img to text
			modality = "text2text";
		}
		const message = {
			userId: user?.userId ?? "",
			message: "",
			conversationId: Number(Id),
			taskType: "data-gpt",
			taskData1: value,
			taskData2: "",
			taskData3: "",
			companyId: "1",
			modality: modality,
			imageList: [],
		} as any;

		if (fileUrl != "") {
			message.imageList = [fileUrl];
			message.message = JSON.stringify({ imageList: [fileUrl] });
		}

		return message;
	};

	const addMessage = (value: string, fileUrl?: any) => {
		const data = JSON.parse(JSON.stringify(selectedChat));
		if (!data.type) {
			data.type = 1;
		}

		if (!data.id) {
			createConversation(JSON.parse(JSON.stringify(data)))
				.then((res: object) => {
					const ress = JSON.parse(JSON.stringify(res));

					// setConversationId(ress.id);
					// setSelectedChat(ress);
					customSetConversationId(ress.id);
					customSetSelectChat(ress);
					setMessageId(ress.id);
					navigate(`/d5data/c/${ress?.id}`);

					// 发信息时先 push 用户的输入进 messages
					const Id = conversationId ? conversationId : ress.id;
					const message = createMessage(Number(Id), value, fileUrl);

					if (user && user?.userId) {
						console.log(selectedChat?.id);
						ress.messages?.push({
							author: "my",
							message: JSON.stringify(message),
						});

						if (fileUrl != "") {
							ress.message?.push({
								author: "my",
								message: fileUrl,
								sendType: "img",
							});
						}

						sendMessage(message);
						// setSelectedChat(ress);
						customSetSelectChat(ress);
					}
				})
				.catch((e: Error) => {
					toast.error(e?.message.toString());
				});
		} else {
			setMessageId(selectedChat?.id);
			handleSendMessageClick(value, fileUrl);
		}
	};

	const handleSendMessageClick = (
		value: string,
		fileUrl?: any,
		id?: number
	) => {
		const Id = conversationId ? conversationId : id;
		// if (current.length > 0) {
		// 	getConversationList(Id);
		// 	setCurrent([]);
		// }

		const message = createMessage(Number(Id), value, fileUrl);
		const newData = JSON.parse(JSON.stringify(selectedChat));

		if (user && user?.userId) {
			// 将用户的输入 push 到 messages 中
			newData.messages.push({
				author: "my",
				message: JSON.stringify(message),
			});

			if (fileUrl != "") {
				newData.message?.push({
					author: "my",
					message: fileUrl,
					sendType: "img",
				});
			}

			// 确保创建新的引用
			// setSelectedChat(newData);
			customSetSelectChat(newData);
			sendMessage(message);
		}
	};

	// 处理文件拖拽
	const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		event.stopPropagation();

		const droppedFile = event.dataTransfer.files[0];
		if (droppedFile && droppedFile.type.startsWith("image/")) {
			const reader = new FileReader();
			reader.onloadend = () => {
				setFile(droppedFile); // 更新拖拽的图片
			};
			reader.readAsDataURL(droppedFile);
		}
	};

	// 处理拖拽悬浮效果
	const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
	};

	useEffect(() => {
		const arr: any = [];
		const list = JSON.parse(JSON.stringify(selectedChat)).messages || [];
		console.log(selectedChat, "selectedChat");

		list.forEach((item: object) => {
			const data = JSON.parse(JSON.stringify(item));
			const obj = {
				name:
					data.author == "assistant"
						? i18n.language == "en"
							? "DOCTA"
							: "第五维度"
						: user?.name,
				type: data.author == "assistant" ? "ai" : "my",
				schedule: data?.jindu !== undefined ? data?.jindu : null,
				data: "",
				model: "",
				response_type: "",
				parsedData: null,
				sendType: data?.sendType,
				imageList: [],
				return_type: "",
			};

			if (isJSON(data.message)) {
				if (obj.type == "ai") {
					const text = JSON.parse(data.message);
					obj.data = data.message?.[0];
					obj.model = text?.model ?? "";
					obj.response_type = text?.status?.response_type;
					obj.parsedData = text?.data;
					obj.return_type = text?.return_type;
					if (text?.modality?.endsWith("img")) {
						setRequireType && setRequireType("img");
					} else {
						setRequireType && setRequireType("text");
					}
				} else {
					const text = JSON.parse(data.message);
					obj.imageList = text?.imageList;
					obj.data = text?.taskData1;
				}
			} else {
				if (data?.imageList?.length > 0) {
					obj.imageList = data?.imageList;
				}
				obj.data = data.message;
			}
			arr.push(obj);
		});

		setChatListData(() => [...arr]); // 更新 chatListData
		setTimeout(() => setCurrent([]), 0);
	}, [selectedChat]);

	const isJSON = (str: string) => {
		try {
			const parsed = JSON.parse(str);
			if (typeof parsed == "number") {
				return false;
			}
			return true;
		} catch (e) {
			return false;
		}
	};

	return (
		<MyContext.Provider
			value={{
				sessionId,
				setSessionId,
				requireType,
				setRequireType,
				selectedChat,
				setSelectedChat: (value) => {
					if (typeof value == "function") {
						const res = value(selectedChat);
						localStorage.setItem(
							"selectedChat",
							JSON.stringify(res)?.toString() ?? {}.toString
						);
					} else {
						setSelectedChat(value);
						localStorage.setItem(
							"selectedChat",
							JSON.stringify(value)?.toString() ?? {}.toString
						);
					}
				},
				isInputValue,
				setIsInputValue,
				conversationId,
				setConversationId: (value) => {
					setConversationId(value);
					localStorage.setItem(
						"conversationId",
						JSON.stringify(value)?.toString()
					);
				},
				isLoad,
				setIsLoad,
				recordList,
				setRecordList,
				hideSide,
				setHideSide,
				file,
				setFile,
				fileUrl,
				setFileUrl,
				addSession,
				seleConversation,
				deleItem,
				message,
				sendMessage,
				streamMessages,
				save,
				handleChange,
				messageId,
				setMessageId,
				current,
				setCurrent,
				needFresh,
				setNeedFresh,
				chatListData,
				setChatListData,
				getConversationList,
				listen,
				setListen,
				// save,
				setSave,
				isLoading,
			}}
		>
			<div
				className={`App docta-ai ${isDarkMode ? "dark-theme" : "light-theme"}`}
			>
				<div
					onDrop={handleDrop}
					onDragOver={handleDragOver}
					className="drop-wrapper"
					style={{ height: "100%" }}
				>
					<div className="docta-ai-body">
						{/* 左侧聊天记录列表 */}
						<DoctaAiRecord
							recordList={recordList}
							setRecordList={setRecordList}
							onHideSide={() => setHideSide(!hideSide)}
							hideSide={hideSide}
						/>
						{/* 右侧 */}
						{/*<Button*/}
						{/*	onClick={()=>{*/}
						{/*		console.log("current.length",current.length)*/}
						{/*		console.log("current", current);*/}
						{/*		console.log("chatListData", chatListData)*/}
						{/*	}}*/}
						{/*>TEST</Button>*/}
						<Outlet />
					</div>
				</div>
			</div>
		</MyContext.Provider>
	);
}

export default DoctaAi;
